import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isNewAutomationModalOpen: false,
  selectedProcess: [],
};

const ConnectedDevicesSlicer = createSlice({
  name: "connectedDevices",
  initialState,
  reducers: {
    setNewAutomationModal: (state, action) => {
      if (typeof action.payload !== "boolean") return;
      state.isNewAutomationModalOpen = action.payload;
    },
    setSelectedProcess: (state, action) => {
      state.selectedProcess = action.payload;
    },
  },
});

export const { setNewAutomationModal, setSelectedProcess } =
  ConnectedDevicesSlicer.actions;

export default ConnectedDevicesSlicer.reducer;
